import { push } from 'redux-first-history';
import { createCommand } from '../../utils';
import { moduleName, roadSectionLineHighlighted } from '../state';

type Args = {
    line: [number, number][];
    overallRate?: number | null;
};

export const NavigateToRoadSectionOnMapCommand = createCommand(
    `${moduleName}/NAVIGATE_TO_ROAD_SECTION_ON_MAP`,
    async ({ line, overallRate }: Args, { dispatch }) => {
        dispatch(roadSectionLineHighlighted({ line, overallRate }));
        dispatch(push('/map'));
    },
);
